<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="22"
    viewBox="0 0 21 22"
    fill="none"
    stroke="currentColor"
  >
    <path
      d="M11.375 3.125L16.625 8.375V18.875H4.375V3.125H11.375Z"
      stroke-width="0.7"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.0645 3.21484L10.8048 7.77336L16.1966 8.08044"
      stroke="#404A57"
      stroke-width="0.7"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M7.875 15.375V12.75" stroke="#404A57" stroke-linecap="round" />
    <path d="M10.5 15.375V11.875" stroke="#404A57" stroke-linecap="round" />
    <path d="M13.125 15.375V11" stroke="#404A57" stroke-linecap="round" />
  </svg>
</template>

<script>
export default {
  name: "IconReport",
};
</script>

<style></style>
